import { UiWrapper } from '@coinscrap/webapp-core';

UiWrapper.defineComponent('slider', {
  styles: {
    default: {},
  },
});
